<div id="itemdetail_card_body">
    <ul id="item_detail_override_card_body">
        <li class="item_detail_header_row breadcrumb-font" id="item_breadcrumbs">
            <span *ngIf="showOutage" style="color: #0079EF; cursor: pointer;"
                [routerLink]='["/outages"]'>{{ 'OutagesList.outages' | translate }} </span>
            <span *ngIf="!showOutage" style="color: #0079EF; cursor: pointer;"
                [routerLink]='["/items"]'>{{ 'ItemDetail.items' | translate }}</span>
            <em class="fa fa-angle-right fa-lg px-1"></em>
            <!-- <span> {{itemDetail.itemBasicInfo.itemName}}</span> -->
            <span> {{ 'ItemDetail.itemdetails' | translate }}</span>

        </li>
    </ul>

    <!-- Row for Item Image, Item Name, Items create requests Icons ( I, C )-->
    <div class="row" id="item_name_description_row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="row">
                <!-- Item Image-->
                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-2 mt-1">
                    <img id="zsd_item_detail_image" class="m-auto" *ngIf="itemDetail.iconData"
                        [src]="_DomSanitizer.bypassSecurityTrustUrl('data:' + itemDetail.iconMime + ';base64, ' + itemDetail.iconData)">
                </div>

                <!-- Item Name-->
                <div class="col-xl-8 col-lg-8 col-md-7 col-sm-11 col-10">
                    <div id="sd_item_name" class="detail-title-font">
                        {{itemDetail.itemBasicInfo.itemName}}
                    </div>
                </div>

                <!-- Item Request Creation -->
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mt-3">
                    <div *ngIf="!showOutage && itemSelectionRequired != 2" id="create_item_request">
                        <span *ngIf="canCreateIncidents" data-toggle="modal" data-target="#zsd_modal_new_request"
                            (click)="createIncident(itemDetail)"><img src="img/incidentPlus.png">&nbsp;</span>
                        <span *ngIf="canCreateChangeRequests" data-toggle="modal" data-target="#zsd_modal_new_request"
                            (click)="createChangeRequest(itemDetail)"><img src="img/changePlus.png"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Item Description-->
    <!-- Moving description out of the header row so more space will be avialable -->
    <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div id="item_description_input" class="mt-3"
                [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(itemDetail.description)"></div>
        </div>
    </div>

    <div class="row mt-3 ml-1">
        <div class="col-md-4 col-lg-2 col-xl-2 col-sm-4 col-4 item_detail_labels">
            {{ 'ItemDetail.category' | translate }}</div>
        <div class="col-md-8 col-lg-4 col-xl-4 col-sm-8 col-8">{{itemDetail.categoryName}}</div>
        <div class="col-md-4 col-lg-2 col-xl-2 col-sm-4 col-4 item_detail_labels">
            {{ 'ItemDetail.itemType' | translate }}</div>
        <div class="col-md-8 col-lg-4 col-xl-4 col-sm-8 col-8">{{itemDetail.itemBasicInfo.itemTypeName}}</div>
    </div>


    <div class="row mt-3 ml-1">
        <div class="col-md-4 col-lg-2 col-xl-2 col-sm-4 col-4 item_detail_labels">{{ 'ItemDetail.status' | translate }}
        </div>
        <div class="col-md-8 col-lg-4 col-xl-4 col-sm-8 col-8">{{itemDetail.itemBasicInfo.itemStatus}}</div>
        <div class="col-md-4 col-lg-2 col-xl-2 col-sm-4 col-4 item_detail_labels">
            {{ 'ItemDetail.serviceLevel' | translate }}</div>
        <div class="col-md-8 col-lg-4 col-xl-4 col-sm-8 col-8">{{itemDetail.itemBasicInfo.serviceLevel}}</div>
    </div>

    <!-- For Custtom Fields -->
    <div class="row d-none d-lg-block d-xl-block" *ngFor="let row of itemDetail.customFields; let i =index">
        <div class="col-6 row mt-3 ml-1" id="custom_field_display" *ngFor="let customField of matrix[i]">
            <div class="col-lg-4 col-xl-4 item_detail_labels">{{customField.displayName}}:</div>
            <div class="col-lg-7 col-xl-7 ml-1">{{customField.value}}</div>
        </div>
    </div>

    <!-- For Custtom Fields in Tablet & Mobile -->
    <div class="row mt-3 ml-1 d-lg-none d-xl-none" *ngFor="let customField of itemDetail.customFields">
        <div class="col-sm-4 col-4 item_detail_labels">{{customField.displayName}}:</div>
        <div class="col-sm-8 col-8">{{customField.value}}</div>
    </div>

    <div class="row" id="item_cancel_button">
        <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
            <div class="float-right">
                <button type="button" [routerLink]="showOutage ? ['/outages'] :['/items']" class="btn zsd_button"
                    id="zsd_cust_button_cancel">{{ 'CommonStrings.cancelButton' | translate}}</button>
            </div>
        </div>
    </div>

</div>

<div *ngIf='customCategory && itemId' class="modal" id="zsd_modal_new_request" data-backdrop="static"
    data-keyboard="false">
    <div class="modal-content">
        <div class="modal-header">
            <div> <img src={{imagePath}}/> <span id="popupHeaderString"> {{ popupHeaderString | translate }} </span></div>
            <button type="button" class="close" data-dismiss="modal" (click)=resetCreateRequest()><em class="fas fa-times"></em></button>
        </div>
        <div class="modal-body" id="override_modal_body">
            <zsd-reportincident [customCategory]=customCategory [itemId]=itemId (clearForm)=resetCreateRequest()>
            </zsd-reportincident>
        </div>
    </div>
</div>